"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Discord = void 0;
const react_1 = __importDefault(require("react"));
require("./Discord.scss");
const consts_1 = require("../../common/consts");
const Discord = () => {
    return (react_1.default.createElement("section", { className: "discord-section", id: consts_1.SECTION_IDS.discord },
        react_1.default.createElement("h2", null, "Join us on Discord!"),
        react_1.default.createElement("div", { className: "contact-methods-wrapper" },
            react_1.default.createElement("div", { className: "contact-method" },
                react_1.default.createElement("a", { href: consts_1.DISCORD_INVITE_URL },
                    react_1.default.createElement("img", { src: "/images/discord-logo.png", height: 50, alt: "discord logo" })),
                react_1.default.createElement("p", null,
                    "Join our ",
                    react_1.default.createElement("a", { href: consts_1.DISCORD_INVITE_URL }, "Discord"),
                    " community to chat with fellow board game enthusiasts, stay updated on events, and share your gaming experiences!")))));
};
exports.Discord = Discord;
